export default __webpack_public_path__ + "assets/community-one-two-small.c5b4dd0a545ace2da19d5826efd791fa.png";